import BrainImg from "../assets/brain.png";
import StrategyImg from "../assets/strategy.png";
import ChatbotImg from "../assets/chatbot.png";
import Watch24Img from "../assets/24.png";
import FootballImg from "../assets/football.png";
import BasketImg from "../assets/basket.png";
import SoccerImg from "../assets/soccer.png";
import BaseballImg from "../assets/baseball.png";
import HockeyImg from "../assets/hockey.png";
import RotoballerImg from "../assets/rotoballer.png";
import ReefineryImg from "../assets/REEFINERY.png";
import MysportsfeedsImg from "../assets/mysportsfeedslogo.png";
import DtcLogoImg from "../assets/dtclogo.png";
import FantasyProsImg from "../assets/FantasyprosLogoWhite.png";

export const features = [
  {
    id: 1,
    img: BrainImg,
    textPrimary: "Artificial Intelligence-Driven Predictions",
    textSecondary: "Predicting player performances with AI helps your users make informed and winning decisions",
  },
  {
    id: 2,
    img: ChatbotImg,
    textPrimary: "Personalized Recommendations",
    textSecondary: "Offer advice tailored to your users' teams, considering both current status and future projections",
  },
  {
    id: 3,
    img: StrategyImg,
    textPrimary: "Custom Brand Integrations",
    textSecondary: "We're committed to enhancing your brand. Collaborate with us to create an application that seamlessly aligns with your brand's look and feel ",
  },
  {
    id: 4,
    img: Watch24Img,
    textPrimary: "24 / 7 Product Availability",
    textSecondary: "Our API is available around the clock, ensuring continuous assistance for your users' needs",
  },
];

export const benefits = [
  {
    id: 1,
    title: "FOR YOUR BRAND",
    subtitle1: "Increase Engagement",
    textPrimary: "RotoGPT attracts more users, boosts retention, and adds new revenue streams to your existing product",
    subtitle2: "Drive Innovation",
    textSecondary: "Stay ahead in the fast-paced world of fantasy sports with RotoGPT's cutting-edge, AI-powered features",
  },
  {
    id: 2,
    title: "FOR YOUR USERS",
    subtitle1: "Save Time",
    textPrimary: "Your users' time is valuable. Equip them with tools for quicker, smarter decision-making",
    subtitle2: "Enhance Experience",
    textSecondary: "RotoGPT's chatbot elevates user engagement and enriches their experience on your platform",
  },
];

export const professionalSports = [
  {
    id: 1,
    img: FootballImg,
    title: "American Football",
  },
  {
    id: 2,
    img: BasketImg,
    title: "Basketball",
  },
  {
    id: 3,
    img: SoccerImg,
    title: "Football",
  },
  {
    id: 4,
    img: BaseballImg,
    title: "Baseball",
  },
  {
    id: 5,
    img: HockeyImg,
    title: "Hockey",
  },
];

export const partnersInnovations = [
  {
    id: 1,
    img: ReefineryImg,
    title: "LEADING CONSULTANTS IN AI TECHNOLOGY",
  },
  {
    id: 2,
    img: RotoballerImg,
    title: "TRUSTED SOURCE IN FANTASY NEWS",
  },
  {
    id: 3,
    img: MysportsfeedsImg,
    title: "RELIABLE PROVIDER OF SPORTS DATA",
  },
];

export const cardsData = [
  { id: 1, title: "MysportsFeeds", description: "Statistics", img: MysportsfeedsImg },
  { id: 2, title: "RotoBaller", description: "News", img: RotoballerImg },
  // { id: 3, title: "Dynasty Trade", description: "Trade Calculator", img: DtcLogoImg },
  { id: 4, title: "FantasyPros", description: "Projections", img: FantasyProsImg },
];
